module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABuSURBVHgB7dIxCoAwDAXQXwjiEMGxY4/gUbyhZ/AmHqFjxw4dC7WLUumidLN5S/gEAoEPiN9TZZgzHnlBg4honXP2ylQumacNSa1oQGnY87hvPD7Q2hiiaNAgBDq8tx7iLWlRRVr0mbSoIi3q0Aks2zltV+2kJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hamburger.png
// module id = 2THF
// module chunks = 1